import BaseApi from './baseApi';
import IListStatusInbound from '../models/IListStatusInbound';
import IAuthentication from '../models/IAuthentication';
export default class ListStatusInboundsApi extends BaseApi {
    idUser : string = "";
    idCompany: string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListStatusInbounds() : Promise<IListStatusInbound[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listStatusInbound: IListStatusInbound[] = [];
            listStatusInbound = response.data as IListStatusInbound[];
            return listStatusInbound;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListStatusInbound(listStatusInbound: IListStatusInbound) : Promise<string> {
        const json = this.getJsonSave(listStatusInbound);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListStatusInbound(listStatusInbound: IListStatusInbound) : Promise<boolean> {
        const json = this.getJsonUpdate(listStatusInbound);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListStatusInbound(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_STATUS_INBOUND_IN_USE",
            "parameters": [{
                "Item1": "StatusInboundId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListStatusInbounds",
                "Item2": "id"
            }, {
                "Item1": "ListStatusInbounds",
                "Item2": "name"
            }, {
                "Item1": "ListStatusInbounds",
                "Item2": "isFinished"
            }, {
                "Item1": "ListStatusInbounds",
                "Item2": "color"
            }, {
                "Item1": "ListStatusInbounds",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "ListStatusInbounds"
            }],
            "conditions": [{
                "Item1": "ListStatusInbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListStatusInbounds",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany,
                "Item5": ""
            }],
            "orderBy": [{
                "Item1": "ListStatusInbounds.name"
            }]
        };
        return json;
    }
    
    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusInbounds",
            "conditions": [{
                "Item1": "ListStatusInbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listStatusInbound: IListStatusInbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusInbound.name
            }, {
                "Item1": "isFinished",
                "Item2": false
            }, {
                "Item1": "color",
                "Item2": listStatusInbound.color
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusInbounds"
        };
        return json;
    }

    private getJsonUpdate(listStatusInbound: IListStatusInbound) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusInbound.name
            }, {
                "Item1": "isFinished",
                "Item2": listStatusInbound.isFinished
            }, {
                "Item1": "color",
                "Item2": listStatusInbound.color
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusInbounds",
            "keyvalue": listStatusInbound.id
        };
        return json;
    }
}
